/**
 * Auth Api
 * Auth Xpo Api which handles all the api restful calls
 *
 * OpenAPI spec version: v3.0.1.0
 * Contact: ea@xpo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { SecretRequest } from '../model/secretRequest';
import { ServiceSecret } from '../model/serviceSecret';
import { ValidationResult } from '../model/validationResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ServicesSecretsService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Services - Create Secret
     * This creates the ServiceSecret, and returns the ServiceSecret                Sample request:                POST /services/{serviceId}/secrets                {                   \&quot;Secret\&quot;:\&quot;sdlkjsdaflkj883kk*djkddj\&quot;,                   \&quot;Description\&quot;:\&quot;integration\&quot;                }
     * @param serviceId 
     * @param secretRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesServiceIdSecretsPost(serviceId: string, secretRequest?: SecretRequest, observe?: 'body', reportProgress?: boolean): Observable<ServiceSecret>;
    public servicesServiceIdSecretsPost(serviceId: string, secretRequest?: SecretRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceSecret>>;
    public servicesServiceIdSecretsPost(serviceId: string, secretRequest?: SecretRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceSecret>>;
    public servicesServiceIdSecretsPost(serviceId: string, secretRequest?: SecretRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling servicesServiceIdSecretsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ServiceSecret>(`${this.configuration.basePath}/services/${encodeURIComponent(String(serviceId))}/secrets`,
            secretRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Services - Delete Secret
     * Deletes the ServiceSecret by ServiceId                Sample request:                DELETE /services/{serviceId}/secrets/{serviceSecretId}
     * @param serviceId The service id.
     * @param serviceSecretId The service secret id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public servicesServiceIdSecretsServiceSecretIdDelete(serviceId: string, serviceSecretId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public servicesServiceIdSecretsServiceSecretIdDelete(serviceId: string, serviceSecretId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public servicesServiceIdSecretsServiceSecretIdDelete(serviceId: string, serviceSecretId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public servicesServiceIdSecretsServiceSecretIdDelete(serviceId: string, serviceSecretId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (serviceId === null || serviceId === undefined) {
            throw new Error('Required parameter serviceId was null or undefined when calling servicesServiceIdSecretsServiceSecretIdDelete.');
        }
        if (serviceSecretId === null || serviceSecretId === undefined) {
            throw new Error('Required parameter serviceSecretId was null or undefined when calling servicesServiceIdSecretsServiceSecretIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/services/${encodeURIComponent(String(serviceId))}/secrets/${encodeURIComponent(String(serviceSecretId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// /ng-app/src/apiModule/api/servicesSecrets.service.ts